function CompAnalyticsPage() {
    return ( <h1>CompAnalytics Page</h1> );
}

export default CompAnalyticsPage;